import $ from 'jquery';
import navToggle from './components/menu';
import mainNav from './components/mainNav';
import header from './components/header';
import cookies from './components/cookies';
import procustTabs from './components/product-tabs';

// Sections
import videoBanner from './components/sections/video-banner';
import { slider, sliderOnlyMobile } from './components/sections/sliders';

$(document).ready(() => {
  header();
  navToggle();
  mainNav();
  cookies();
  videoBanner();
  slider();
  sliderOnlyMobile();
  procustTabs();
});
